export enum BroadcastChannelEnum {
  SW_CHANNEL_VIDEO = 'sw-channel-video',
  SW_CHANNEL_LIVENESS = 'sw-channel-liveness',
  SW_CHANNEL_VIDEO_CACHE_REQUEST = 'sw-channel-video-cache-request',
  SW_CHANNEL_VIDEO_CACHE_RESPONSE = 'sw-channel-video-cache-response',
}

export enum BroadcastChannelMessageEnum {
  // Video
  VIDEO_LOAD_FAILED = 'message-synchronized',

  // Health check
  LIVENESS_FETCH_FAILED = 'message-liveness-failed',
  LIVENESS_FETCH_SUCCEEDED = 'message-liveness-succeeded',

  // CALLS TO SERVICE WORKER
  GET_CACHED_VIDEOS_ID = 'GET_CACHED_VIDEOS_ID',
  DELETE_CACHED_VIDEOS = 'DELETE_CACHED_VIDEOS',
  DELETE_ALL_CACHED_VIDEOS = 'DELETE_ALL_CACHED_VIDEOS',
}
